/**
 * Extract a human-readable error message from an Axios error, a raw BE response
 * envelope (`{ errors: [{ message }], meta }`), or a generic Error instance.
 *
 * Returned message ORIGINATES FROM BACKEND when the error has an `errors[0]`
 * payload. UI callers that render this message in DOM (e.g. step row `note`,
 * inline form errors, toasts) inherit whatever the BE wrote — including any
 * PHI the BE may have embedded into an exception path. This app handles PHI
 * (healthcare/insurance). Callers MUST either trust BE-side sanitization OR
 * sanitize before rendering. Do NOT route this message into URL params,
 * browser storage, or error-tracking metadata (see security baseline rule).
 */
export const getErrorMessage = (err) => {
  const data = err?.response?.data;
  // BE returns errors either as a top-level array (`[{ message }]`) or wrapped
  // in `{ errors: [...] }`. Support both, then fall back to `data.message`.
  // `err?.errors?.[0]` covers a raw BE envelope passed without the Axios wrapper.
  const fromList = Array.isArray(data)
    ? data?.[0]?.message
    : data?.errors?.[0]?.message;
  const msg =
    fromList || data?.message || err?.errors?.[0]?.message || err?.message;
  return ['Request timed out', 'Request was cancelled', 'cancelled'].includes(
    msg
  )
    ? 'Request timed out. Please try again or check your connection.'
    : msg;
};
